import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Images", href: "/images", current: true },
];
export default function Images() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="images">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}